import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import {connect} from "react-redux"

import {FormattedMessage} from "@irati/utils/lang"
import {H4} from "@irati/ui/src/Typography"
import {Hr} from "@irati/ui/src/Layout"
import DealLocationsQueryComponent from "@irati/deals/apollo/query/DealLocations"
import {DEFAULT_RADIUS_METERS} from "@irati/geolocation/src/constants/proximity"
import {hasValidValues} from "@irati/geolocation/src/helpers/latLng"
import id from "@irati/utils/id"
import Address from "@irati-web/geolocation/src/components/Address/Address"
import tracking from "@irati-tracking/perks/perks"

import LocationsMap from "./LocationsMap"
import {GoToMapButton, LocationsMapWrapper} from "./styled/DealLocations"
import LocationsMapPopup from "./Popup/LocationsMap"

class DealLocations extends PureComponent {
  static propTypes = {
    deal: PropTypes.shape({
      uuid: PropTypes.string.isRequired
    }).isRequired,
    userLocation: PropTypes.shape({
      latLng: PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired
      }).isRequired
    }).isRequired,
    isMobile: PropTypes.bool.isRequired
  }

  state = {
    viewTrackingSent: false
  }

  setViewTracking = () => {
    if (!this.state.viewTrackingSent) {
      this.setState({
        viewTrackingSent: true
      }, () => {
        tracking.viewPerkNearestLocation(this.props.deal)
      })
    }
  }

  handleGoToMapButtonClick = () => {
    this.mapPopup.show()
  }

  render() {
    const {isMobile, deal, userLocation} = this.props
    const {latLng: {lat, lng}} = userLocation
    const variables = {
      dealId: deal.uuid,
      lat,
      lng,
      radius: DEFAULT_RADIUS_METERS,
      offset: 0,
      limit: 100
    }
    const idNamespace = id("locations", this.props)
    if (!hasValidValues(lat, lng)) { return null }
    return (
      <DealLocationsQueryComponent variables={variables} useLoader={false}>
        {({data: {dealLocations}}) => {
          if (!dealLocations || !dealLocations.results.length) { return null }
          this.setViewTracking()
          const locationsData = dealLocations.results
          const selectedLocation = locationsData[0]
          const {streetAddress, city, postCode} = selectedLocation

          return (
            <section id={idNamespace}>
              <Hr large />
              <H4 marginBottom={2}><FormattedMessage id="perks.dealLocations.header" /></H4>
              <Address title={streetAddress} city={city} postCode={postCode} />
              {isMobile ? (
                <GoToMapButton onClick={this.handleGoToMapButtonClick}>
                  <FormattedMessage id="perks.dealLocations.goToMapButton.text" />
                </GoToMapButton>
              ) : (
                <LocationsMapWrapper>
                  <LocationsMap deal={deal} selectedLocation={selectedLocation} locationsData={locationsData} />
                </LocationsMapWrapper>
              )}
              <LocationsMapPopup
                selectedLocation={selectedLocation}
                locationsData={locationsData}
                deal={deal}
                ref={(c) => { this.mapPopup = c }} />
            </section>
          )
        }}
      </DealLocationsQueryComponent>
    )
  }
}

const mapStateToProps = ({geoLocation, mq}) => ({userLocation: geoLocation.userLocation, isMobile: mq.lessThan.large})

export default connect(mapStateToProps)(DealLocations)
